// extracted by mini-css-extract-plugin
export default {"buttonElement":"Button_buttonElement__iharD","secondary":"Button_secondary__QwN49"};